import React, {useEffect, useRef, useState, useContext} from 'react';
// import logo from "../assets/images/logo.jpeg";
import logo from "../assets/images/logo.gif";
import ApplicationContext from './ApplicationContext';
import { setLocalStorage } from './Utils';

// const flagMap = {
// 	 de: '🇩🇪', fr: '🇫🇷', en: '🇬🇧', es: '🇪🇸', ja: '🇯🇵', iw: '🇮🇱', pt: '🇵🇹', ar: '🇸🇦', 
// 	 ko: '🇰🇷', fa: '🇮🇷', 'zh-CN': '🇨🇳', 'zh-TW': '🇹🇼', hi: '🇮🇳', nl: '🇳🇱', ru: '🇷🇺', tr: '🇹🇷', vi: '🇻🇳', 
// 	 no: '🇳🇴', sv: '🇸🇪', fi: '🇫🇮', bn: '🇧🇩', ur: '🇵🇰', el: '🇬🇷', is: '🇮🇸', it: '🇮🇹', fil: '🇵🇭', id: '🇮🇩', 
// 	 th: '🇹🇭'
// };

const getElementByXpath = (path) =>
	document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
	
const googleTranslateElementInit = () => {
	new window.google.translate.TranslateElement({
		// pageLanguage: 'en',
		// autoDisplay: false,
		includedLanguages: 'de,fr,en,es,ja,iw,pt,ar,ko,fa,zh-CN,zh-TW,hi,nl,ru,tr,vi,no,sv,fi,bn,ur,el,is,it,fil,id,th,uk,sr,hr,sl',
		// layout: google.translate.TranslateElement.InlineLayout.HORIZONTAL
		// layout: google.translate.TranslateElement.InlineLayout.SIMPLE
	}, 'google_translate_element');
};

const restore = (e) => {
	e.preventDefault();
	const elem = document.getElementById(':1.container').contentWindow.document.getElementById(':1.restore')
	elem.click();
	let notSelected = getElementByXpath("//div[@id='google_translate_element']//select/option[@value='']");
	notSelected.innerHTML = "Language";
};

// const setFlagIcons = () => {
// 	console.log(`DEBUG:  setFlagIcons started here.`);
// 	// let options = getElementByXpath("//div[@id='google_translate_element']//select/option");
// 	let options = document.getElementsByClassName('goog-te-combo')[0];
// 	for (let i = 0; i < options.length; i++) {
// 		if (i !== 0) {
// 			let value = options[i].value;
// 			options[i].innerHTML = flagMap[value];
// 			console.log(`DEBUG:  options[i].innerHTML - ${options[i].innerHTML}`);
// 		}
// 	}
// };

const Header = ({onLanguageChange}) => {
	const loaded = useRef(false);
	const data = useContext(ApplicationContext);

	const [width, setWidth] = useState("250px");
	useEffect(() => {
		const handleWindowResize = () => {
			// console.log(`DEBUG:  window.innerWidth - ${window?.innerWidth}`);
			setWidth(window?.innerWidth <= 367 ? "150px" : "250px");
		};
		window.addEventListener('resize', handleWindowResize);
		return () => {
			window.removeEventListener('resize', handleWindowResize);
		};
	});

	useEffect(() => {
		if (loaded.current === false) {
			loaded.current = true;
			const addScript = document.createElement('script');
			addScript.setAttribute(
				'src',
				'//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
			);
			document.body.appendChild(addScript);
			window.googleTranslateElementInit = googleTranslateElementInit;

			setTimeout(() => {
				let notSelected = getElementByXpath("//div[@id='google_translate_element']//select/option[@value='']");
				if (notSelected) {
					notSelected.innerHTML = "Language";
					// setFlagIcons();
				}
			}, 1000);

			document.getElementById("google_translate_element").addEventListener('change', (e) => {
				// console.log(`DEBUG:  Header - new value = ${JSON.stringify(e.target.value)}`);
				data.lang = e.target.value;
				setLocalStorage('CURRENT_LANG', e.target.value);
				onLanguageChange(e.target.value);  // Pass the selected language to the parent
				// setFlagIcons();

				if (e.target.value === 'en') {
					// console.log("DEBUG:  Header changed language is english");
					e.preventDefault();
					restore(e);
				}
			});
		}
	}, [data, onLanguageChange]);

	return (
		<div className="header" >
			<div className="logo-container">
				<div>
					<img src={logo} alt="DAYSEENK" style={{maxWidth: "250px", width: width}} />
				</div>
			</div>
			<div>
				<div className="translate-a">
					<div id="google_translate_element"></div>
					{/* <a href="#"><img className="close-button" width="15" height="15" onClick="restore(event)" /></a> */}
				</div>
			</div>
		</div>
	);
}

export default Header;
